import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { CaricaFatturaPRSummaryComponent } from './carica-fattura-pr-summary';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.carica-fattura-pr-summary', {
            url: '/carica-fattura-pr-summary',
            ncyBreadcrumb: {
                label: 'Carica Fattura Riepilogo',
                parent: 'home.fatturazione-pr'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Carica fattura Riepilogo'
            },
            'views': {
                'homeContent': {
                    template: '<carica-fattura-pr-summary flex="100"></carica-fattura-pr-summary>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const CaricaFatturaPRSummaryModule: string = ng
    .module('carica-fattura-pr-summary', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('caricaFatturaPrSummary', CaricaFatturaPRSummaryComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/carica-fattura-pr-summary/carica-fattura-pr-summary.module.ts